import InterfaceService from "../../interface/InterfaceService";
import InterfaceSection from "../../interface/InterfaceSection";

export enum SessionStorageKeys {
  SERVICE = "service",
  SECTION = "section",
  DATE_AND_TIME = "dateAndTime"
}

export enum BookingUrls {
  SERVICE = "/bestill/tjeneste",
  SECTION = "/bestill/trafikkstasjon",
  DATE_AND_TIME = "/bestill/tidspunkt",
  CONTACT = "/bestill/kontakt",
  CONFIRMATION = "/bestill/bekrefte",
  RECEIPT = "/bestill/kvittering",
}

export type SessionStorageTypes = {
  key: SessionStorageKeys.SECTION | SessionStorageKeys.SERVICE | SessionStorageKeys.DATE_AND_TIME
} & (
  {
    key: SessionStorageKeys.SERVICE
    value: InterfaceService
  }
  |
  {
    key: SessionStorageKeys.SECTION
    value: InterfaceSection
  }
  |
  {
    key: SessionStorageKeys.DATE_AND_TIME
    value: string
  }
  )
//Magic numbers fra Ventus
export enum TjenesteIDer {
  TEORI = 438,
  FORERKORT = 436,
  REGISTRERING = 437
}